import config from "../config/app.conf.json";

export default (entityId, uid) => ({
  url: `${config.api.organizations_url}/organizations/${entityId}/users`,
  method: "POST",
  data: {
    userIds: [uid]
  }
});
